'use client'

import React, { useState } from 'react'

import { ITravelTypeContext, TravelTypeContext } from './TravelTypeContext'
import { TravelTypeEnum } from '../../../lib/graphql'

export function TravelTypeContextProvider({
  children,
  defaultTravelType = TravelTypeEnum.NIGHTLY_TRIP,
}: {
  children: React.ReactNode
  defaultTravelType?: TravelTypeEnum
}) {
  const [travelType, setTravelType] =
    useState<TravelTypeEnum>(defaultTravelType)

  const context: ITravelTypeContext = {
    travelType,
    setTravelType,
  }

  return (
    <TravelTypeContext.Provider value={context}>
      {children}
    </TravelTypeContext.Provider>
  )
}
